var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5747_4771)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5747_4771)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#B3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7243 45.6667H58.6092L60.3832 55.9419C60.6434 57.449 61.1912 58.8919 61.9968 60.1918C62.0952 60.3506 61.9811 60.5556 61.7943 60.5556H37.4212C37.2882 60.5556 37.2086 60.4078 37.2817 60.2967C38.1817 58.9299 38.7848 57.3894 39.052 55.7748L40.7243 45.6667Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8889 50.1111C36.8889 48.1474 38.4808 46.5555 40.4445 46.5555H59.3334C61.297 46.5555 62.8889 48.1474 62.8889 50.1111C62.8889 52.0748 61.297 53.6667 59.3334 53.6667H40.4445C38.4808 53.6667 36.8889 52.0748 36.8889 50.1111Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3334 47.2222H40.4445C38.849 47.2222 37.5556 48.5156 37.5556 50.1111C37.5556 51.7066 38.849 53 40.4445 53H59.3334C60.9288 53 62.2222 51.7066 62.2222 50.1111C62.2222 48.5156 60.9288 47.2222 59.3334 47.2222ZM40.4445 46.5555C38.4808 46.5555 36.8889 48.1474 36.8889 50.1111C36.8889 52.0748 38.4808 53.6667 40.4445 53.6667H59.3334C61.297 53.6667 62.8889 52.0748 62.8889 50.1111C62.8889 48.1474 61.297 46.5555 59.3334 46.5555H40.4445Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1045 95.5717C22.3833 82.5944 29.8869 69.0576 42.8642 65.3364C55.8415 61.6152 69.3783 69.1188 73.0995 82.0961L73.8958 84.8731C77.617 97.8504 70.1134 111.387 57.1361 115.108C44.1588 118.83 30.622 111.326 26.9008 98.3487L26.1045 95.5717Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.255 85.0569L72.4587 82.2799C68.839 69.6565 55.6713 62.3576 43.048 65.9773C30.4246 69.597 23.1256 82.7646 26.7453 95.388L27.5416 98.1649C31.1613 110.788 44.3289 118.087 56.9523 114.468C69.5757 110.848 76.8746 97.6802 73.255 85.0569ZM42.8642 65.3364C29.8869 69.0576 22.3833 82.5944 26.1045 95.5717L26.9008 98.3487C30.622 111.326 44.1588 118.83 57.1361 115.108C70.1134 111.387 77.617 97.8504 73.8958 84.8731L73.0995 82.0961C69.3783 69.1188 55.8415 61.6152 42.8642 65.3364Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4443 58.7778H56.6666V65.8889H42.4443V58.7778Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9999 59.4445H43.111V65.2223H55.9999V59.4445ZM42.4443 58.7778V65.8889H56.6666V58.7778H42.4443Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1113 58.7778H56.0002V67.6667H43.1113V58.7778Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 40.2222C39.3335 34.3925 44.0594 29.6666 49.8891 29.6666C55.7187 29.6666 60.4446 34.3925 60.4446 40.2222V52C60.4446 57.8296 55.7187 62.5555 49.8891 62.5555C44.0594 62.5555 39.3335 57.8296 39.3335 52V40.2222Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7779 52V40.2222C59.7779 34.7607 55.3505 30.3333 49.8891 30.3333C44.4276 30.3333 40.0002 34.7607 40.0002 40.2222V52C40.0002 57.4614 44.4276 61.8888 49.8891 61.8888C55.3505 61.8888 59.7779 57.4614 59.7779 52ZM49.8891 29.6666C44.0594 29.6666 39.3335 34.3925 39.3335 40.2222V52C39.3335 57.8296 44.0594 62.5555 49.8891 62.5555C55.7187 62.5555 60.4446 57.8296 60.4446 52V40.2222C60.4446 34.3925 55.7187 29.6666 49.8891 29.6666Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 42.5555H41.7778L40 46.7778V42.5555Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7778 42.5555H58.0001L59.7778 46.7778V42.5555Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7478 67.4445C61.3107 70.9032 56.1683 73.633 49.889 73.633C43.646 73.633 38.5269 70.9347 38.0383 67.5045C29.6759 69.8994 23.5557 77.6019 23.5557 86.7338V101.845H76.4446V86.7338C76.4446 77.5241 70.2196 69.7683 61.7478 67.4445Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3189 72.4261C56.0832 73.5989 53.1181 74.2997 49.889 74.2997C46.6784 74.2997 43.7292 73.607 41.4981 72.4465C39.5686 71.4429 38.0873 70.0367 37.5508 68.3509C29.8125 70.8769 24.2223 78.1533 24.2223 86.7338V101.178H75.7779V86.7338C75.7779 78.0788 70.0901 70.7506 62.2473 68.2862C61.732 69.9893 60.253 71.4115 58.3189 72.4261ZM61.6075 68.0973C60.6496 71.2405 55.7675 73.633 49.889 73.633C44.0464 73.633 39.1882 71.2697 38.1885 68.155C38.12 67.9415 38.0696 67.7245 38.0383 67.5045C37.822 67.5664 37.6073 67.6319 37.3941 67.7009C29.3634 70.2988 23.5557 77.838 23.5557 86.7338V101.845H76.4446V86.7338C76.4446 77.7601 70.5346 70.1668 62.3946 67.6337C62.1805 67.5671 61.9649 67.504 61.7478 67.4445C61.7199 67.6652 61.6728 67.883 61.6075 68.0973Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2983 37.3734C38.2983 34.6036 40.0109 32.1224 42.6006 31.1401L43.6951 30.7249C47.7572 29.1841 52.2429 29.1841 56.3051 30.7249L57.3995 31.1401C59.9893 32.1224 61.7018 34.6036 61.7018 37.3734V43.6667H38.2983V37.3734Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0352 43.0001V37.3734C61.0352 34.8806 59.4938 32.6475 57.1631 31.7634L56.0686 31.3483C52.1588 29.8652 47.8413 29.8652 43.9316 31.3483L42.8371 31.7634C40.5063 32.6475 38.965 34.8806 38.965 37.3734V43.0001H61.0352ZM42.6006 31.1401C40.0109 32.1224 38.2983 34.6036 38.2983 37.3734V43.6667H61.7018V37.3734C61.7018 34.6036 59.9893 32.1224 57.3995 31.1401L56.3051 30.7249C52.2429 29.1841 47.7572 29.1841 43.6951 30.7249L42.6006 31.1401Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 5.75,
    width: 78.5,
    height: 78.5,
    rx: 39.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5747_4771",
    x: 0.909091,
    y: 0.454545,
    width: 98.1818,
    height: 98.1818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.54545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.54545
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5747_4771"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5747_4771",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5747_4771"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric04);
export default __webpack_public_path__ + "static/media/Generic 04.d9fe61aab003e1d8d0d64db45df8d45a.svg";
export { ForwardRef as ReactComponent };